import React, { useEffect, useState } from 'react';
import { PhoneIcon } from 'lucide-react';
import { contact } from '../data/contact';
const links = [{
  href: '#prestations',
  label: 'Prestations'
}, {
  href: '#methode',
  label: 'La méthode'
}, {
  href: '#contact',
  label: 'Contact'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full border-b transition-colors duration-200 ease-out ${scrolled ? 'border-sand-200 bg-sand-100/95 backdrop-blur' : 'border-transparent bg-transparent'}`} data-id="element-53" data-mp="31bfaja5jal34">
      <div className="mx-auto flex h-20 w-full max-w-6xl items-center justify-between px-6" data-id="element-54" data-mp="3bb69pp51ho9j">
        <a href="#top" className="flex items-baseline gap-2 font-display text-xl text-ink" data-id="element-55" data-mp="3fcrpbi8ykgnf">
          <span className="font-semibold" data-id="element-56" data-mp="2wl4csinw1sci">Passion</span>
          <span className="text-brique" data-id="element-57" data-mp="2wihym06hselb">Rénovation</span>
        </a>

        <nav aria-label="Navigation principale" className="hidden items-center gap-8 md:flex" data-id="element-58" data-mp="2rk6orpg76433">
          {links.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-ink-soft transition-colors duration-150 ease-out hover:text-brique focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brique" data-id="element-59" data-mp="2mohua0j1bddn">
              {link.label}
            </a>)}
        </nav>

        <a href={contact.phoneHref} className="inline-flex items-center gap-2 rounded-full bg-ink px-5 py-2.5 text-sm font-semibold text-sand-50 transition-colors duration-150 ease-out hover:bg-brique focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brique" data-id="element-60" data-mp="35jg2migxkm3w">
          <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="1rd1jgtpy4hib" />
          <span className="hidden sm:inline" data-id="element-62" data-mp="1rfo0rl2n2bdq">{contact.phoneLabel}</span>
          <span className="sm:hidden" data-id="element-63" data-mp="1wbcvnb3pr43p">Appeler</span>
        </a>
      </div>
    </header>;
}